import React from 'react'

import './style.scss'

const Section = props => {
  return (
    <section class={'section ' + props.type + ' ' + props.className}>
      {props.children}
    </section>
  )
}

export default Section
